module.exports = "<h1>Who's this guy?</h1>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/01-bio/01.pug
// module id = 316
// module chunks = 1